<div class="aayn-ad-type-sections" [ngClass]="className">
  <ng-content select="aayn-ad-type-section"></ng-content>
</div>
